export const createShopifyCustomer = async (customerDetails) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/shopify/create-customer`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(customerDetails),
    }
  );

  return await response.json();
};
